import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=464e5b09&scoped=true"
import script from "./sharePage.vue?vue&type=script&lang=js"
export * from "./sharePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e5b09",
  null
  
)

export default component.exports